import { Component, Input, OnInit, inject } from '@angular/core';
import { InboundFax } from '../../../core/models/inbound-fax.model';
import { InboundFaxesService } from '../../../core/services/inbound-faxes.service';
import { InboundFaxCapture } from '../../../core/models/capture-lists/inbound-fax-capture.model';
import { DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CaptureStatusPipe } from 'app/shared/pipes/capture-status.pipe';

@Component({
    selector: 'app-inbound-fax-captures',
    templateUrl: './inbound-fax-captures.component.html',
    imports: [RouterLink, MatProgressSpinner, DatePipe, CaptureStatusPipe]
})
export class InboundFaxCapturesComponent implements OnInit {
  private inboundFaxesService = inject(InboundFaxesService);

  @Input() inboundFax: InboundFax;

  loading = true;
  captures: InboundFaxCapture[] = [];

  ngOnInit() {
    this.loadCaptures();
  }

  private loadCaptures() {
    this.inboundFaxesService.getCaptures(this.inboundFax).subscribe((captures: InboundFaxCapture[]) => {
      this.loading = false;
      this.captures = captures;
    });
  }
}
